import React, { useState, useEffect } from 'react';
import { Form, Button, Row, Col, Alert } from 'react-bootstrap';
import Header from './header';
import Navbar from './navbar';
import Sidebar from './sidebar';
import { useLocation, Link, useNavigate } from 'react-router-dom';
import useAuth from './useAuth';
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import { FaUser } from 'react-icons/fa';
import { parsePhoneNumber } from 'libphonenumber-js';



const Profil_utilisateur = ({ titre }) => {
  useAuth(); // Vérifier l'authentification
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const user_id = localStorage.getItem('IDDDD');

  // Utilisation de useEffect pour mettre à jour le titre de la page
  useEffect(() => {
    if (user_id) {
      document.title = "eTrainApp | Profil"; // Définit le titre de la page
    }
  }, [user_id]);


  


  const [userData, setUserData] = useState({
    email: '',
    nom: '',
    prenoms: '',
    tel: '',
    sexe: '',
    profession: ''
  });

  // Variable d'état pour stocker les données utilisateur initiales
  const [initialUserData, setInitialUserData] = useState(userData);

  const [message, setMessage] = useState('');
  const [showMessage, setShowMessage] = useState(false);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await fetch(process.env.REACT_APP_HOTE + `/recup-info-profil/${user_id}/`);
        if (!response.ok) throw new Error('Erreur réseau');
        const data = await response.json();
        setUserData(data);
        setInitialUserData(data); // Stocker les données initiales
      } catch (error) {
      }
    };

    fetchUserData();
  }, [user_id]);

  const handleChange = (e) => {
    if (e && e.target && e.target.name) {
      setUserData({
        ...userData,
        [e.target.name]: e.target.value
      });
    }
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(process.env.REACT_APP_HOTE + `/modifier-profil-utilisateur/${user_id}/`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(userData)
      });
      if (!response.ok) throw new Error('Erreur réseau');
      const result = await response.json();

      // Afficher le message éphémère
      setMessage('Profil mis à jour avec succès.');
      setShowMessage(true);
      setTimeout(() => {
        setShowMessage(false);
        navigate(`/`);
      }, 3000);

      // Navigate(`/profil_utilisateur`);
    } catch (error) {
    }
  };

  // Gérer les changements du champ de téléphone (numéro complet + indicatif pays)

  const handlePhoneChange = (value) => {
    setUserData({
      ...userData,
      tel: value, // Numéro formaté
    });
  };

  const handleReset = () => {
    setUserData(initialUserData); // Réinitialiser aux valeurs initiales
  };

  return (
    <div id="wrapper">
      <Sidebar user_id={user_id} titre={titre} />
      <div id="page-wrapper" className="gray-bg">
        <Navbar />
        <div>
          <div className="row wrapper border-bottom white-bg page-heading">
            <div className="col-lg-12">
              <h2 className='d-flex align-items-center'><FaUser size={25} className='mr-2' />Mon Profil</h2>
              <small>Ici vous pouvez consulter ou modifier vos Informations.</small>

              <small id='hbreadcrumb' className='d-flex justify-content-end'>
                <ol className="breadcrumb custom-breadcrumb">
                  <li className="breadcrumb-item custom-breadcrumb-item">
                    {/* Utiliser Link de react-router-dom pour la navigation */}
                    <Link to={`/Profil-utilisateur`}>Mon Profil</Link>
                  </li>
                </ol>
              </small>
            </div>
          </div>
          <div className="container mt-5">
            <div className="row">
              <div className="col-lg-2"></div>
              <div className="col-lg-8">
                {/* <h3>Informations d'identité</h3> */}
                {showMessage && (
                  <Alert variant="success" onClose={() => setShowMessage(false)}>
                    {message}
                  </Alert>
                )}
                <div className="hpanel mb-5">
                  <div className="panel-body styled-panel">
                    <div className="mb-4 text-center">
                      <i className="fa fa-user-circle login-logo" style={{ fontSize: '50px' }}></i>
                    </div>
                    <h3 className="font-bold text-center">Consultez votre profil</h3>
                    <Form onSubmit={handleSubmit} className="reg-page">
                      <Row>

                        <Col md={6}>
                          <Form.Group className="mb-3" controlId="nom">
                            <Form.Label>Nom</Form.Label>
                            <Form.Control
                              type="text"
                              name="nom"
                              value={userData.nom}
                              onChange={handleChange}
                              className="custom-input"
                            />
                          </Form.Group>
                        </Col>

                        <Col md={6}>
                          <Form.Group className="mb-3" controlId="prenoms">
                            <Form.Label>Prénoms</Form.Label>
                            <Form.Control
                              type="text"
                              name="prenoms"
                              value={userData.prenoms}
                              onChange={handleChange}
                              className="custom-input"
                            />
                          </Form.Group>
                        </Col>

                        <Col md={6}>
                          <Form.Group className="mb-3" controlId="email">
                            <Form.Label>Email</Form.Label>
                            <Form.Control
                              type="email"
                              name="email"
                              placeholder={userData.email}
                              readOnly
                              className="custom-input"
                            />
                          </Form.Group>
                        </Col>

                        <Col md={6}>
                          <Form.Group className="mb-3" controlId="tel">
                            <Form.Label>Téléphone WhatsApp</Form.Label>
                            <PhoneInput
                              value={userData.tel}
                              onChange={handlePhoneChange}
                              inputStyle={{ width: '100%', padding: '33px' }}
                              containerStyle={{ width: '100%' }}
                              inputProps={{
                                name: 'tel',
                                required: true,
                              }}
                              dropdownStyle={{
                                maxHeight: '500px',
                                overflowY: 'auto',
                                zIndex: 1050,
                              }}
                            />
                          </Form.Group>
                        </Col>

                        <Col md={6}>
                          <Form.Group className="mb-3" controlId="profession">
                            <Form.Label>Profession</Form.Label>
                            <Form.Control
                              type="text"
                              name="profession"
                              value={userData.profession}
                              onChange={handleChange}
                              className="custom-input"
                            />
                          </Form.Group>
                        </Col>

                        {/* <Col md={6}>
                          <Form.Group className="mb-3" controlId="diplome">
                            <Form.Label>Diplôme le plus élevé</Form.Label>
                            <Form.Select
                              name="diplome"
                              value={userData.diplome}
                              onChange={handleChange}
                              className="custom-select"
                            >
                              <option value="BAC">BAC</option>
                              <option value="BTS">BTS</option>
                              <option value="Licence">Licence</option>
                              <option value="Master1">Master1</option>
                              <option value="Master2">Master2</option>
                              <option value="Doctorat">Doctorat</option>
                              <option value="Ingénieur">Ingénieur</option>
                              <option value="Autres">Autres</option>
                            </Form.Select>
                          </Form.Group>
                        </Col> */}

                        <Col md={6}>
                          <Form.Group className="mb-3" controlId="sexe">
                            <Form.Label>Sexe</Form.Label>
                            <Form.Select
                              name="sexe"
                              value={userData.sexe}
                              onChange={handleChange}
                              className="custom-select"
                            >
                              <option value="">Choisir sexe...</option>
                              <option value="Masculin">Masculin</option>
                              <option value="Féminin">Féminin</option>
                            </Form.Select>
                          </Form.Group>
                        </Col>

                        {/* <Col md={6}>
                          <Form.Group className="mb-3" controlId="sexe">
                            <Form.Label>Formation</Form.Label>
                            <Form.Select
                              type='text'
                              name="formation"
                              value={userData.formation}
                              onChange={handleChange}
                              className="custom-select"
                            // readOnly
                            >
                              <option value="">Choisir une formation</option>
                              {formation.map((formation) => (
                                <option key={formation.id} value={formation.nom}>
                                  {formation.nom} {formation.option}
                                </option>
                              ))}
                            </Form.Select>
                          </Form.Group>
                        </Col> */}
                      </Row>

                      <div className="text-center">
                        <Button type="button" variant="default" onClick={handleReset}>
                          Annuler
                        </Button>
                        <Button type="submit" variant="success" className="ml-2">
                          Modifier
                        </Button>
                      </div>
                    </Form>
                  </div>
                </div>
              </div>

              <div className="col-lg-2"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profil_utilisateur;
